export const Header = () => ({
  closeAll() {
    this.$store.menuSearchOpen = false;
    this.$store.menuLanguageSwitcherOpen = false;
    this.$store.menuMobileOpen = false;
    this.$store.menuDesktopOpen = false;
  },
  openSearch() {
    this.closeAll();
    this.$store.menuSearchOpen = true;
  },
  toggleSearch() {
    if (this.$store.menuSearchOpen) this.$store.menuSearchOpen = false;
    else this.openSearch();
  },
  openLanguageSwitcher() {
    const keepMobileOpen = this.$store.menuMobileOpen;
    this.closeAll();
    this.$store.menuMobileOpen = keepMobileOpen;
    this.$store.menuLanguageSwitcherOpen = true;
  },
  toggleLanguageSwitcher() {
    if (this.$store.menuLanguageSwitcherOpen) this.$store.menuLanguageSwitcherOpen = false;
    else this.openLanguageSwitcher();
  },
  openMobileMenu() {
    this.closeAll();
    this.$store.menuMobileOpen = true;
  },
  toggleMobileMenu() {
    if (this.$store.menuMobileOpen) this.$store.menuMobileOpen = false;
    else this.openMobileMenu();
  },
  openMenuItem(id) {
    this.closeAll();
    this.$store.menuDesktopOpen = id;
  },
  toggleMenuItem(id) {
    if (this.$store.menuDesktopOpen === id) this.$store.menuDesktopOpen = false;
    else this.openMenuItem(id);
  }
});
